export default __webpack_public_path__ + "static/media/leopard-print-elevator-by-kevin-macleod-from-filmmusic-io.1d4c5e88.mp3";